import script from "./loan-repayments-report.vue?vue&type=script&setup=true&lang=js"
export * from "./loan-repayments-report.vue?vue&type=script&setup=true&lang=js"

import "./loan-repayments-report.vue?vue&type=style&index=0&id=61ec1e88&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ec1e88"]])

export default __exports__